/**
 * One user send's id, minted once per send and kept by its Retry: the server
 * answers an enqueue that repeats it with the turn it already queued, so a
 * send whose answer was lost is never queued twice.
 */
export function newClientTurnId(): string {
  return typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `turn_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}
